module.exports = __webpack_public_path__ + "static/media/PierSans-Bold.6a5bb744.otf";